import React from 'react';
import { WeatherType } from 'types';

export const getWeatherIcon = (type: WeatherType): JSX.Element => {
  switch (type) {
    case WeatherType.Sunny:
      return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-yellow-500">
          <circle cx="12" cy="12" r="4" fill="#F59E0B" />
          <line x1="12" y1="2" x2="12" y2="4" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" />
          <line x1="12" y1="20" x2="12" y2="22" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" />
          <line x1="4" y1="12" x2="2" y2="12" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" />
          <line x1="20" y1="12" x2="22" y2="12" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" />
          <line x1="6.34" y1="6.34" x2="4.93" y2="4.93" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" />
          <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" />
          <line x1="6.34" y1="17.66" x2="4.93" y2="19.07" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" />
          <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" />
        </svg>
      );
    case WeatherType.Cloudy:
      return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-gray-500">
          <path 
            d="M5.5,15C3.57,15 2,13.43 2,11.5C2,9.73 3.32,8.29 5.05,8.05C5.28,5.22 7.73,3 10.5,3C13.43,3 15.79,5.37 15.73,8.29C17.57,8.63 19,10.26 19,12.25C19,14.32 17.32,16 15.25,16H5.5Z" 
            fill="#9CA3AF" 
            stroke="#6B7280" 
            stroke-width="1.5" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          />
          <path 
            d="M17.5,18C16.12,18 15,16.88 15,15.5C15,14.21 16.01,13.13 17.29,13.02C17.45,11.03 19.13,9.5 21.15,9.5C23.27,9.5 25,11.23 24.96,13.34C26.22,13.58 27.15,14.68 27.15,16C27.15,17.38 26.03,18.5 24.65,18.5H17.5Z" 
            transform="scale(0.8) translate(7, 10)" 
            fill="#D1D5DB" 
            stroke="#9CA3AF" 
            stroke-width="1.5" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          />
        </svg>
      );
    case WeatherType.Rainy:
      return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500">
          <path 
            d="M5.5,14C3.57,14 2,12.43 2,10.5C2,8.73 3.32,7.29 5.05,7.05C5.28,4.22 7.73,2 10.5,2C13.43,2 15.79,4.37 15.73,7.29C17.57,7.63 19,9.26 19,11.25C19,13.32 17.32,15 15.25,15H5.5Z" 
            fill="#9CA3AF" 
            stroke="#6B7280" 
            stroke-width="1.5" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          />
          <line x1="8.5" y1="17" x2="7.5" y2="21" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" />
          <line x1="12" y1="17" x2="11" y2="21" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" />
          <line x1="15.5" y1="17" x2="14.5" y2="21" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" />
          <line x1="7" y1="16" x2="6.5" y2="18" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" />
          <line x1="10.5" y1="16" x2="10" y2="18" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" />
          <line x1="14" y1="16" x2="13.5" y2="18" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" />
          <line x1="17" y1="16" x2="16.5" y2="18" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      );
    default:
      return <span>No icon</span>;
  }
};
